import MuiTab, { TabProps } from '@mui/material/Tab';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

import styles, { tabClasses } from './styles';

const useStyles = makeStyles(styles);

const Tab = ({ className, ...rest }: TabProps) => {
  const classes = useStyles();
  const classProps = clsx(className, classes.tab, tabClasses.root);

  return <MuiTab data-testid="of-tab" className={classProps} {...rest} />;
};

export default Tab;
